import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

function socketUrl(): string | undefined {
  const u = import.meta.env.VITE_API_URL;
  if (u === undefined || u === '') return undefined;
  return u;
}

const socketOptions = {
  autoConnect: false,
  withCredentials: true,
  transports: ['websocket', 'polling'] as ('websocket' | 'polling')[],
};

export function getSocket(): Socket {
  if (!socket) {
    const url = socketUrl();
    socket = url ? io(url, socketOptions) : io(socketOptions);
  }
  return socket;
}

export function connectSocket(token: string): Socket {
  const s = getSocket();
  if (!s.connected) {
    s.auth = { token };
    s.connect();
  }
  return s;
}

export function disconnectSocket(): void {
  if (socket?.connected) {
    socket.disconnect();
  }
}
